(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/widgets/racing2/assets/javascripts/helpers/handlebars-helpers.js') >= 0) return;  svs.modules.push('/widgets/racing2/assets/javascripts/helpers/handlebars-helpers.js');

'use strict';

function registerHelpers(hbs) {
  hbs.registerHelper('concat', function () {
    const args = Array.prototype.slice.call(arguments);
    let concatString = '';
    for (let i = 0; i < args.length - 1; i++) {
      concatString += args[i];
    }
    return concatString;
  });
}
if (typeof exports === 'object') {
  registerHelpers(require('hbs'));
} else {
  registerHelpers(Handlebars);
}

 })(window);